import type { VideoSource } from '../../../../shared/protocol';
import type { PlayerCapabilities } from './VideoProvider';

const fullyControllable: PlayerCapabilities = {
  canPlay: true,
  canPause: true,
  canSeek: true,
  canGetPosition: true,
  canSync: true,
};

export function getVideoCapabilities(source: VideoSource): PlayerCapabilities {
  if (source.provider === 'iframe' || (source.provider === 'twitch' && source.kind === 'clip')) {
    return { canPlay: false, canPause: false, canSeek: false, canGetPosition: false, canSync: false };
  }
  if (source.provider === 'twitch' && source.kind === 'channel') {
    return { canPlay: true, canPause: true, canSeek: false, canGetPosition: false, canSync: true };
  }
  return fullyControllable;
}
